import {ROUTES_PATHS} from "./routes";
import {EnvironmentEnum} from "../enums/environment.enum";
import {CodePermissionEnum} from "../enums/code-permission.enum";

export const menuItemsHeader = [
	{
		label: 'Accueil',
		path: ROUTES_PATHS.WELCOME,
		environment: [EnvironmentEnum.DEV, EnvironmentEnum.PROD],
		permission: CodePermissionEnum.Header_Home_Access
	},
	{
		label: 'Mon compte',
		path: ROUTES_PATHS.MON_COMPTE,
		environment: [EnvironmentEnum.DEV, EnvironmentEnum.PROD],
		permission: CodePermissionEnum.Header_MyAccount_Access
	},
	{
		label: 'Déconnexion',
		path: '',
		environment: [EnvironmentEnum.DEV, EnvironmentEnum.PROD],
		permission: CodePermissionEnum.Header_Logout_Access
	}
]
